import React from 'react';
import './CareersPage.css';

const CareersPage: React.FC = () => {
  React.useEffect(() => {
    const elements = Array.from(document.querySelectorAll<HTMLElement>('.careers .reveal'));
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          (e.target as HTMLElement).classList.add('in-view');
        }
      });
    }, { threshold: 0.12 });
    elements.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
  return (
    <section className="careers">
      <header className="careers__hero reveal">
        <h1 className="careers__title">Work at Wrap.</h1>
        <p className="careers__subtitle">Be a part of something amazing.</p>
      </header>

      {/* Flowing dotted lines background */}
      <svg className="flowBG" viewBox="0 0 1800 520" preserveAspectRatio="none" aria-hidden>
        <g fill="none" stroke="rgba(208, 208, 208, 0.17)" strokeWidth="1.1" strokeLinecap="round" strokeDasharray="2 12">
          {/* three highly loopy, vertically spaced paths that traverse full width */}
          <path className="flowBG__path p1" d="M-200 60 C 80 10, 220 140, 340 60 S 540 40, 640 140 S 820 40, 960 120 S 1140 60, 1260 140 S 1480 80, 1600 120 S 1720 60, 2000 100"/>
          <path className="flowBG__path p2" d="M-100 220 C 60 300, 220 200, 360 280 S 560 240, 680 320 S 860 260, 1000 340 S 1200 300, 1340 380 S 1540 340, 1660 400 S 1780 360, 1900 380"/>
          <path className="flowBG__path p3" d="M-100 360 C 100 420, 260 340, 380 420 S 600 380, 740 440 S 940 400, 1100 460 S 1360 420, 1520 480 S 1680 440, 1900 460"/>
        </g>
      </svg>

      <div className="careers__section reveal" style={{ ['--delay' as any]: '100ms' }}>
      </div>

      <div className="pillGroup reveal" style={{ ['--delay' as any]: '200ms' }}>
        <div className="pillKicker">ENGINEERING</div>
        <a className="pill reveal" style={{ ['--delay' as any]: '320ms' }} href="/careers/full-stack-engineer">
          <div className="pill__left">
            <div className="pill__title">Full Stack Developer</div>
            <div className="pill__meta">Remote • $20/hr • Full Time</div>
          </div>
          <div className="pill__arrow">↗</div>
        </a>
      </div>

      <div className="pillGroup reveal" style={{ ['--delay' as any]: '200ms' }}>
        <div className="pillKicker">MARKETING</div>
        <a className="pill reveal" style={{ ['--delay' as any]: '320ms' }} href="/careers/ugc-creator">
          <div className="pill__left">
            <div className="pill__title">UGC Creator</div>
            <div className="pill__meta">Remote • $15/hr • Part Time</div>
          </div>
          <div className="pill__arrow">↗</div>
        </a>
        <a className="pill reveal" style={{ ['--delay' as any]: '420ms' }} href="/careers/growth-intern">
          <div className="pill__left">
            <div className="pill__title">Growth Intern</div>
            <div className="pill__meta">Remote • $15/hr • Full Time</div>
          </div>
          <div className="pill__arrow">↗</div>
        </a>
      </div>
    </section>
  );
};

export default CareersPage;


